import { Subject } from 'rxjs'
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { IconLink } from 'www/svg-icons/lib/icon-link';
import CloseXSVG from 'www/svg-icons/close-x';
import {TooltipApi} from './tooltip-api';

class TooltipLayer{
    constructor(api) {
        this._el = null;
        this._tooltipApi = api;
        this._onMouseEnter = null;
        this._onMouseLeave = null;
        this._isHoverActive = false;
        this._showCloseButton = true;
    }
    init(){
        this.isVisibleSubscriber = this.tooltipApi.state.pipe(distinctUntilChanged(null, state=>{
            return state.isTooltipVisible;
        })).subscribe( (state )=>{
            this.handleIsLayerVisibleChange(state.isTooltipVisible);
        })
        if(this.showCloseButton){
            this.closeButton.onClick.subscribe(e=>{
                this.tooltipApi.hideTooltip(true);
            })
        }

        if(this.isHoverActive){
            
            this.el.addEventListener('mouseenter',this.handleMouseEnter.bind(this))
            this.el.addEventListener('mouseleave',this.handleMouseLeave.bind(this))
            this.onMouseEnter.subscribe(e=>{
                this.tooltipApi.setMouseOverTooltip(true);
                this.tooltipApi.showTooltip();
            })
            this.onMouseLeave.subscribe(e=>{
                this.tooltipApi.setMouseOverTooltip(false);
            })
            this.onMouseLeave.pipe(debounceTime(100)).subscribe(e=>{
                this.tooltipApi.hideTooltip();
            })
        }
    }
    get isHoverActive(){
        return this._isHoverActive;
    }
    get showCloseButton(){
        return this._showCloseButton;
    }
    get onMouseEnter(){
        if(this._onMouseEnter==null){
            this._onMouseEnter = new Subject();
        }
        return this._onMouseEnter;
    }
    get onMouseLeave(){
        if(this._onMouseLeave==null){
            this._onMouseLeave = new Subject();
        }
        return this._onMouseLeave;
    }
    get tooltipApi(){
        if(this._tooltipApi==null){
            this._tooltipApi = new TooltipApi();
        }
        return this._tooltipApi;
    }
    get el() {
        if (this._el == null) {
            let el = document.createElement('div');
            el.classList.add('medscape-tooltip-layer');
            let arrowEl = document.createElement('div');
            arrowEl.classList.add('arrow');
            el.appendChild(arrowEl);
            if(this.showCloseButton){
                el.appendChild(this.closeButtonEl);
            }
            this._el = el;
        }
        return this._el;
    }
    get closeButton(){
        if(this._closeButton==null){
            this._closeButton = new IconLink(CloseXSVG.useSprite);
            this._closeButton.el.classList.add('close-x-icon');
        }
        return this._closeButton;
    }
    get closeButtonEl(){
        if(this._closeButtonEl==null){
            let el = document.createElement('span');
            el.classList.add('close-button-container');
            el.appendChild(this.closeButton.el);
            this._closeButtonEl = el;
        }
        return this._closeButtonEl;
    }
    handleMouseEnter(e){
        this.onMouseEnter.next(e);
    }
    handleMouseLeave(e){
        this.onMouseLeave.next(e);
    }
    handleIsLayerVisibleChange(isVisible=this.tooltipApi.state.isTooltipVisible) {
        if(isVisible){
            this.el.classList.add("is-visible")
            this.el.style.display="";
        }
        else{
            this.el.classList.remove("is-visible")
            this.el.style.display="none";
        }
        //this.labelContainer.innerHTML = this.labelText;
    }

}

export { TooltipLayer }